import { render, staticRenderFns } from "./Buttonv2.vue?vue&type=template&id=4778cd35&"
import script from "./Buttonv2.vue?vue&type=script&lang=js&"
export * from "./Buttonv2.vue?vue&type=script&lang=js&"
import style0 from "./Buttonv2.vue?vue&type=style&index=0&id=4778cd35&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports